import { HttpMethod } from '../../constants';
export const geolocationEndpoints = {
  [HttpMethod.Get]: {
    Location: {
      path: '/geolocation/location',
      route(): string {
        return this.path;
      }
    }
  }
};
export default geolocationEndpoints;